import React, { useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import Img1 from '../assets/images/interior-designer.jpg';
import Img2 from '../assets/images/realtors.jpg';
import Img3 from '../assets/images/for-property.jpg';
const items = [
    {
        title: "For interior designers",
        image: Img1,
        link: "/interior-designers"
    },
    {
        title: "For realtors",
        image: Img2,
        link: "/real-estate"
    },
    {
        title: "For interior designers",
        image: Img1,
        link: "/interior-designers"
    },
    {
        title: "For realtors",
        image: Img2,
        link: "/real-estate"
    }

];

const IveyForYou = () => {

    const navigate = useNavigate();

    const isDragging = useRef(false);

    const handleMouseDown = () => {
        isDragging.current = false;
    };

    const handleMouseMove = () => {
        isDragging.current = true;
    };

    const handleClick = (link) => {
        if (!isDragging.current) {
        navigate(link);
        }
    };

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '78px',
        arrows: false,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '50px'
                }
            }
        ]
    };

    return (
        <>
            <div className='ivey-for-you-section bg-black pt-60 pb-70 d-py-100'>
                <div className='wrapper ps-30 d-ps-80'>
                    <div className='grid-blocks d-flex align-center gap-50 d-gap-0'>
                        <div className='grid-block left-block color-light'>
                            <h2 className='mb-20 font-38'>Ivey <span className="font-medium">for you</span></h2>
                            <div className='text-block mb-30'>
                                Explore our service offering and experience tailored for your business and your needs.
                            </div>
                            <ul className='ivey-list d-grid gap-10'>
                                <li className='uppercase font-regular font-12'>For Interior Designers</li>
                                <li className='uppercase font-regular font-12'>For Real Estate</li>
                            </ul>
                        </div>
                        <div className='grid-block right-block'>
                            <Slider {...settings}>
                                {items.map((item, index) => (
                                    <div key={index} className="ivey-slide pe-10">
                                        <div className='iveyforyou-item position-relative d-flex flex-column justify-end cursor-pointer'
                                            onMouseDown={handleMouseDown}
                                            onMouseMove={handleMouseMove}
                                            onClick={() => handleClick(item.link)}
                                            onTouchStart={handleMouseDown}
                                            onTouchMove={handleMouseMove}>
                                            <img src={item.image} alt={item.title} className='cover position-absolute top-0 start-0' />
                                            <div className='title-block color-light px-30 pb-30 z-index-1'>
                                                <Link to={item.link}><h2 className='font-22'>{item.title}</h2></Link>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default IveyForYou